import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "preferred-store-name",
  class PreferredStoreName extends WYATTElement {
    constructor() {
      super();

      this.name = this.querySelector("[data-name]");
      this.handlePreferredStoreChange =
        this.handlePreferredStoreChange.bind(this);
    }

    connectedCallback() {
      this.syncStoreName();

      this.subscribe(
        WYATT.PubSub.events.preferredStoreChange,
        this.handlePreferredStoreChange,
      );
    }

    syncStoreName() {
      if (!this.name) {
        return;
      }

      const store = WYATT.PreferredStores?.store;

      if (!store?.name) {
        return;
      }

      this.name.textContent = store.name;
    }

    handlePreferredStoreChange(store) {
      if (!store?.name) {
        return;
      }

      this.name.textContent = store.name;
    }
  },
);
